module.exports = __webpack_public_path__ + "img/21_73.86c677fe.png";